import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { EditEmployeeForm } from '@/features/employee/edit-employee-form'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/employees/update/$employeeId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { employeeId } = Route.useParams()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование сотрудника')}>
      <EditEmployeeForm onClose={close} employeeId={employeeId} />
    </Offcanvas>
  )
}
